import script from "./MonthCloses.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthCloses.vue?vue&type=script&setup=true&lang=js"

import "./MonthCloses.vue?vue&type=style&index=0&id=55db1a7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55db1a7a"]])

export default __exports__